import {colors, fontSizes, fonts, spacings, shadow, layout} from 'style';

const style= {
    container: {
        ...fonts.body,
        lineHeight: '1.5',
        minHeight:'100%', 
        padding:'0px 10px 0px 10px',
        textAlign: 'center',
        color: colors.themeDarkerGrey,
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
    },
    containerDiv: {
        marginLeft: 'auto',
        marginRight: 'auto',
        height:'100%', 
        backgroundColor: 'white',
    },
    segment: {
        height:'100%', 
        textAlign: 'center',
        backgroundColor: 'white',
    },
    grid: {
        height: '100%',
        backgroundColor: 'white',
        marginTop: '0px',
        marginBottom: '0px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    row: {
        backgroundColor: 'white',
    },
    header:{ 
        fontSize: fontSizes.h2,
        lineHeight: '1.5',
        color: colors.themeBlue,
        paddingBottom: spacings.large,
        textAlign: 'center',
    },
    ratingsWrapper: {
        padding: spacings.large,
    },
    ratings: {
        fontSize: fontSizes.h1,
    },
    iconWrapper: {
        marginTop: spacings.xlarge,
        marginBottom: spacings.xlarge,
    },
    icon: {
        color: colors.themeDarkerGrey,
        fontSize: '100px',
        lineHeight: '1',
    },
    tealButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
        width: '330px',
        boxShadow: shadow,
    },
    disabledButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeDarkerGrey,
        color: '#fff',
        width: '330px',
        opacity: '0.50',
        boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 4px 0px',
    },
    message: {
        display: 'inline-block',
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '330px',
        boxShadow: 'none',
        padding: '.78571429em 1.5em .78571429em',
    },
    skip: {
        ...fonts.body,
        lineHeight: '1.5',
        textDecoration: 'underline',
        color: colors.themeBlue,
        marginTop: spacings.large,
        marginBottom: spacings.base,
        cursor: 'pointer',
    },
    description: {
        width: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingBottom: spacings.large,
    },
    subheading: {
        textAlign: 'center',
        color: colors.themeBlue,
    },
};

export default style;



// WEBPACK FOOTER //
// ./src/modules/onboarding/style.js